import { render, staticRenderFns } from "./CertificateIndex.vue?vue&type=template&id=1cbf9146&scoped=true"
import script from "./CertificateIndex.vue?vue&type=script&lang=js"
export * from "./CertificateIndex.vue?vue&type=script&lang=js"
import style0 from "./CertificateIndex.vue?vue&type=style&index=0&id=1cbf9146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf9146",
  null
  
)

export default component.exports